module.exports = __webpack_public_path__ + "img/logo.aedce7d9.png";